module.exports = __webpack_public_path__ + "img/right.a5ca1f72.svg";